import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { StyledText, VerifyAddressContainer } from './styled';
import MemoizedUserAddress from '../UserAddress';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { paymentSelector } from '../../redux/PaymentState/PaymentState.selectors';
import { getString } from '../../constants/Strings';
import { FormContainer, FormWrapper } from '../PaymentForm/styled';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { verifyUserProvidedBillingAddress } from './verifyUserProvidedBillingAddress';
import { getPaymentServerErrorText } from '../PaymentForm/helpers';
import { PaymentFormDataFields } from '../UserAddress/constants';
var VerifyAddress = function VerifyAddress() {
  var dispatch = useDispatch();
  var config = useAppSelector(configSelector);
  var payment = useAppSelector(paymentSelector);
  var didAddressUpdate = config.didAddressUpdate,
    paymentErrorModal = config.paymentErrorModal;
  var billingAddress = payment.billingAddress,
    thirdPartyBraintreePayload = payment.thirdPartyBraintreePayload,
    deviceData = payment.deviceData;
  useEffect(function () {
    if (didAddressUpdate) {
      var details = thirdPartyBraintreePayload.details;
      var userProvidedBillingAddress = details.billingAddress;

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (userProvidedBillingAddress) {
        verifyUserProvidedBillingAddress({
          thirdPartyBraintreePayload: thirdPartyBraintreePayload,
          billingAddress: billingAddress,
          dispatch: dispatch,
          deviceData: deviceData
        });
      }
    }
  }, [didAddressUpdate]);
  return /*#__PURE__*/React.createElement(VerifyAddressContainer, null, /*#__PURE__*/React.createElement(StyledText, null, /*#__PURE__*/React.createElement("span", null, getPaymentServerErrorText(paymentErrorModal, PaymentFormDataFields.VERIFY_ADDRESS) || getString('APP.FORM.HEADER.VERIFY.ADDRESS'))), /*#__PURE__*/React.createElement(FormWrapper, {
    id: 'pm-address-verify-form',
    "data-test": DataTestAttributes.VERIFY_ADDRESS_FORM
  }, /*#__PURE__*/React.createElement(FormContainer, {
    "data-test": DataTestAttributes.VERIFY_ADDRESS_FORM_CONTAINER
  }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement(MemoizedUserAddress, {
    thirdPartyBraintreePayload: thirdPartyBraintreePayload
  })))));
};
export default VerifyAddress;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/VerifyAddress/index.js
// module id = 1502
// module chunks = 11